"use client"

import { Suspense } from "react"
import { useSports } from "hooks"
import { SportSkeleton } from "compositions/events/Sport/Sport"
import { LeagueSkeleton } from "compositions/events/League/League"
import TopEvents from "compositions/events/TopEvents/TopEvents"
import EmptyContent from "compositions/events/EmptyContent/EmptyContent"
import Navbar, { NavbarSkeleton } from "compositions/events/Navbar/Navbar"
import OvertimeUniqueEvents from "@/compositions/events/UniqueEvents/OvertimeUniqueEvents"
import OvertimeFilteredLeagues from "@/compositions/events/FilteredLeagues/OvertimeFilteredLeagues"
import OverTimeSport from "@/compositions/events/Sport/OverTimeSport"
import { filterSportsWithChildMarkets } from "@/utils/filterSportsWithChildMarkets"

const LoadingSkeleton = () => {
  return (
    <>
      <NavbarSkeleton />
      <SportSkeleton>
        <LeagueSkeleton />
      </SportSkeleton>
    </>
  )
}

const OvertimeSportsContent: React.FC = () => {
  const { sports, loading } = useSports()

  if (loading) {
    return <LoadingSkeleton />
  }

  if (!sports) {
    return <EmptyContent />
  }

  // Filter sports to only include those with games that have childMarkets
  const filteredSports = filterSportsWithChildMarkets(sports)

  return (
    <Navbar>
      {filteredSports.map((sport, sportIndex) => (
        <OverTimeSport key={sport.slug} sport={sport}>
          {sport.slug === "unique" ? (
            <OvertimeUniqueEvents
              leagues={sport.leagues}
              isFirstSport={sportIndex === 0}
            />
          ) : (
            <OvertimeFilteredLeagues
              sportSlug={sport.slug}
              leagues={sport.leagues}
              isFirstSport={sportIndex === 0}
            />
          )}
        </OverTimeSport>
      ))}
    </Navbar>
  )
}

const OvertimeSports: React.FC = () => {
  return (
    <Suspense fallback={<LoadingSkeleton />}>
      <OvertimeSportsContent />
    </Suspense>
  )
}

export default function OvertimeHomePage() {
  return (
    <Suspense>
      <div className="px-2">
        <Suspense fallback={<LoadingSkeleton />}>
          <TopEvents />
        </Suspense>
        <OvertimeSports />
      </div>
    </Suspense>
  )
}
